import React from 'react'
import { XStack, YStack } from 'tamagui'

import { Card } from '@newComponents/Card'
import { Icon } from '@newComponents/Icon'
import { Paragraph } from '@newComponents/Text'
import { Link } from '@newComponents/Link'

import { DocSection } from '../shared/DocSection'

const AttendeeForms = () => (
  <>
    <Card gap='$4'>
      <Paragraph size='$5'>
        Attendee forms let organizers collect additional information from people
        when they RSVP or purchase tickets. This is useful for gathering details
        like dietary requirements, t-shirt sizes, accessibility needs, company
        names, or any other information that helps you plan a better Event.
      </Paragraph>
      {/* TODO: Capture screenshot of Event Settings → Attendee Forms section showing custom form fields */}
    </Card>

    <Card gap='$4'>
      <DocSection id='form-management' title='Form Management'>
        <YStack gap='$3'>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='settings' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>Setting up forms</Paragraph> — Open{' '}
              <Link href='/docs/events/settings'>Event Settings</Link> and go to the
              Attendee Forms section. Add custom fields with labels and input types.
              Each field can be marked as required or optional, so you can collect
              essential information without creating friction for attendees.
            </Paragraph>
          </XStack>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='person' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>Attendee experience</Paragraph>{' '}
              — When attendees RSVP or go through the{' '}
              <Link href='/docs/events/purchase-flow'>ticket purchase flow</Link>, they
              see the custom form fields alongside the standard registration fields.
              The form is presented inline, so attendees complete everything in a
              single step.
            </Paragraph>
          </XStack>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='search' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>Viewing responses</Paragraph>{' '}
              — Organizers can view all form responses from the attendee list in Event
              Settings. Responses are shown alongside each attendee's profile, making
              it easy to see who needs what at a glance. You can also export attendee
              data including form responses for offline planning.
            </Paragraph>
          </XStack>
        </YStack>
      </DocSection>
    </Card>

    <Card gap='$4'>
      <DocSection id='form-updates' title='Updating Forms'>
        <Paragraph size='$5'>
          Forms can be added or updated at any time, even after attendees have
          already RSVPed. Existing attendees are not required to fill out newly
          added fields, but new attendees will see them during registration.
        </Paragraph>
      </DocSection>
    </Card>
  </>
)

export default AttendeeForms
